import * as alerts from '../actions/alerts';

const defaultState = {
    alert: {
        message: '',
        theme: 'success',
        section: '',
    },
    alertBoxIds: [],
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case alerts.SET_ALERT:
            return {
                ...state,
                alert: {
                    message: action.message,
                    theme: action.theme,
                    section: action.section,
                },
            };
        case alerts.CLEAR_ALERT:
            return {
                ...state,
                alert: { ...defaultState.alert },
            };
        case alerts.REGISTER_ALERTBOX:
            return {
                ...state,
                alertBoxIds: [...state.alertBoxIds, action.id],
            };
        case alerts.UNREGISTER_ALERTBOX:
            return {
                ...defaultState,
                alertBoxIds: state.alertBoxIds.filter((id) => id !== action.id),
            };
        default:
            return state;
    }
}
